import React from 'react';
import { Download, Image as ImageIcon } from 'lucide-react';
import type { SocialPostDesign, SocialPostProduct } from '../../services/socialPosting';

export type { ExportFormat, ExportOptions } from './canvas/exportUtils';

interface SocialExporterProps {
  postId: string;
  designs: SocialPostDesign[];
  products: SocialPostProduct[];
}

export function SocialExporter({ designs }: SocialExporterProps) {
  if (designs.length === 0) {
    return (
      <div className="text-center py-24">
        <ImageIcon className="h-12 w-12 text-muted-foreground mx-auto mb-4" />
        <p className="text-muted-foreground">No designs to export.</p>
        <p className="text-sm text-muted-foreground mt-1">Create a design first in the Design tab.</p>
      </div>
    );
  }

  return (
    <div className="text-center py-24">
      <Download className="h-12 w-12 text-muted-foreground mx-auto mb-4" />
      <p className="text-muted-foreground">
        Use the <strong>Export</strong> button in the canvas editor toolbar to download your designs.
      </p>
      <p className="text-sm text-muted-foreground mt-2">
        Open any design from the Design tab, then click Export in the top-right corner.
      </p>
    </div>
  );
}
